import {AttributeType} from '@viamedici-spc/configurator-ts';

export function attributeIdToString(attributeId) {
	const sharedModel = attributeId.sharedConfigurationModelId && `shared::${attributeId.sharedConfigurationModelId}`;
	const componentPath = (attributeId.componentPath ?? []).join('::');

	return [
		sharedModel,
		componentPath,
		attributeId.localId
	]
		.filter(s => s !== null && s !== '')
		.join('::');
}

/**
 * Converts an attribute ID object to a string-represented path.
 *
 * @param {GlobalConstraintId} constraintId - The attribute ID object.
 * @returns {string} The formatted string representation of the attribute ID.
 */
export function constraintIdToString(constraintId) {
	return `${constraintId.configurationModelId}::${constraintId.localId}`;
}
/**
 * Converts a attribute represented as path to an attributeId object.
 *
 * @param {String} attributeName - The attribute ID object.
 * @returns {Object} the attributeId Object
 */
export function stringToAttributeId(attributeName) {
	const attributeParts = attributeName.split('::');
	const attributeId = {};
	// localId only
	if (attributeParts.length === 1) {
		attributeId.localId = attributeParts[0];
		return attributeId;
	}
	// root attribute
	if (attributeParts.length > 1 && attributeParts[0] === 'root') {
		attributeParts.shift(); // remove 'root'
		attributeId.localId = attributeParts.pop();
	}
	// shared attribute
	if (attributeParts.length > 2 && attributeParts[0] === 'shared') {
		attributeParts.shift(); // remove 'shared'
		attributeParts.sharedConfigurationModelId = attributeParts.shift();
	}
	// add component Path
	attributeId.componentPath = attributeParts.length > 0 ? attributeParts : null; // remaining parts are component path
	return attributeId;
}

export function attributeKeyToId(attributeKey) {
	const attributeParts = attributeKey.split('::');
	const attributeId = {};

	if (attributeParts[0] === 'root') {
		attributeId.localId = attributeParts[attributeParts.length - 1];
		attributeId.componentPath = attributeParts.slice(1, attributeParts.length - 1);
	}
	if (attributeParts[0] === 'shared') {
		attributeId.sharedConfigurationModelId = attributeParts[1];
		attributeId.localId = attributeParts[attributeParts.length - 1];
		attributeId.componentPath = attributeParts.slice(2, attributeParts.length - 1);
	}
	return attributeId;
}

// map decisions from spc session to stored decisions
// [{type, attributeId, state, choiceValueId}]
export function spcToStoredDecisions(decisions) {
	return decisions?.map(decision => {
		const dec = {
			type: decision.attributeType,
			attributeId: decision.attributeId,
			state: decision.state
		};
		if (decision.attributeType === AttributeType.Choice) {
			dec.choiceValueId = decision.choiceValueId;
		}
		return dec;
	});
}

export function mergeSpcDecisions(a, b) {
	//console.log('mergeSpcDecisions', a, b);
	const reduced = a.filter(
		aitem => !b.find(bitem => aitem.attributeId.localId === bitem.attributeId.localId)
	);
	return reduced.concat(b);
}
